// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-cold-wallets-api';

export const useListColdWallets: typeof hookExports.useListColdWallets =
  hookExports.useListColdWallets;
export const useLazyListColdWallets: typeof hookExports.useLazyListColdWallets =
  hookExports.useLazyListColdWallets;
export const useFormatAddress: typeof hookExports.useFormatAddress = hookExports.useFormatAddress;
export const useLazyFormatAddress: typeof hookExports.useLazyFormatAddress =
  hookExports.useLazyFormatAddress;
export const useListColdWalletSnapshots: typeof hookExports.useListColdWalletSnapshots =
  hookExports.useListColdWalletSnapshots;
export const useLazyListColdWalletSnapshots: typeof hookExports.useLazyListColdWalletSnapshots =
  hookExports.useLazyListColdWalletSnapshots;
export const useListProjectSnapshots: typeof hookExports.useListProjectSnapshots =
  hookExports.useListProjectSnapshots;
export const useLazyListProjectSnapshots: typeof hookExports.useLazyListProjectSnapshots =
  hookExports.useLazyListProjectSnapshots;
export const useLinkColdWallet: typeof hookExports.useLinkColdWallet =
  hookExports.useLinkColdWallet;
export const useUnlinkColdWallet: typeof hookExports.useUnlinkColdWallet =
  hookExports.useUnlinkColdWallet;
export const useUpdateColdWallet: typeof hookExports.useUpdateColdWallet =
  hookExports.useUpdateColdWallet;
export const useCreateColdWalletSnapshot: typeof hookExports.useCreateColdWalletSnapshot =
  hookExports.useCreateColdWalletSnapshot;
